import React from "react";
import { Tooltip } from "@my-scoot/component-library-legacy";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import classnames from "classnames";
import { ClickRatePopover } from "common/Components/ClickRatePopover";
import { POPOVER_TEXT_BROADCAST } from "../../constants";
import { STATS_FIELDS } from "ui/pages/communications/CustomEmail/components/EmailListItem/EmailListItem.constants";

export const DataItem = ({
  data,
  title,
  titleClassName,
  dataClassName,
  tooltip,
}) => {
  return (
    <div>
      <div
        className={classnames(
          "tw-text-[20px] tw-font-bold tw-mb-[4px]",
          dataClassName
        )}
      >
        {data}
        {tooltip ? (
          title === STATS_FIELDS.clickRate ? (
            <ClickRatePopover
              tooltipText={tooltip}
              popoverText={POPOVER_TEXT_BROADCAST}
              shouldAutoOpen={true}
              iconStyle={{ marginLeft: 12 }}
              fontSize={12}
            />
          ) : (
            <Tooltip
              arrow
              color="primary"
              placement="top"
              title={tooltip}
              className="tw-text-[#777] tw-ml-[12px]"
            >
              <InfoIcon className="info" fontSize="12" />
            </Tooltip>
          )
        ) : null}
      </div>
      <div
        className={classnames(
          "tw-text-[16px] tw-text-[#272522]",
          titleClassName
        )}
      >
        {title}
      </div>
    </div>
  );
};
